import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth.js';

const API_BASE_URL = import.meta.env['VITE_API_URL'] ?? 'http://localhost:3000';

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#fff"
        d="M21.6 12.23c0-.77-.07-1.5-.19-2.23H12v4.22h5.4a4.6 4.6 0 0 1-2 3.02v2.5h3.23c1.9-1.75 2.97-4.33 2.97-7.5z"
      />
      <path
        fill="#fff"
        d="M12 22c2.7 0 4.96-.9 6.62-2.42l-3.23-2.5c-.9.6-2.05.96-3.39.96-2.6 0-4.8-1.76-5.6-4.12H3.06v2.6A10 10 0 0 0 12 22z"
      />
      <path
        fill="#fff"
        d="M6.4 13.92A6 6 0 0 1 6.08 12c0-.67.11-1.32.32-1.92v-2.6H3.06A10 10 0 0 0 2 12c0 1.6.38 3.12 1.06 4.52z"
      />
      <path
        fill="#fff"
        d="M12 6.5c1.47 0 2.79.5 3.82 1.5l2.87-2.87C16.95 3.36 14.7 2.5 12 2.5A10 10 0 0 0 3.06 8.48l3.34 2.6C7.2 8.72 9.4 6.5 12 6.5z"
      />
    </svg>
  );
}

// Login.tsx no usa <Layout /> — pantalla completa, sin sidebar/topbar.
export function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const errorParam = params.get('error');

    if (token) {
      login(token);
      navigate('/clientes', { replace: true });
      return;
    }

    if (errorParam) {
      setError('No fue posible iniciar sesión. Verifica que tu cuenta sea @leadsphere.com.');
    }
  }, [navigate, login]);

  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/google`;
  };

  return (
    <div className="login-split">
      <div className="login-branding">
        <div className="login-branding-inner">
          <div className="login-brand-mark">
            <div className="login-brand-isotipo">NX</div>
            <div className="login-brand-name">
              <strong>Nexus</strong>
              <span>by Leadsphere</span>
            </div>
          </div>
          <p className="login-brand-copy">
            La plataforma centralizada que <strong>potencia tu crecimiento</strong>. Conecta tus datos de comercio
            electrónico, optimiza tus leads y acelera tus ventas desde un solo lugar.
          </p>
        </div>
      </div>

      <div className="login-panel">
        <div className="login-card">
          <div className="login-card-icon">LS</div>
          <h1 className="login-title">Bienvenido</h1>
          <p className="login-subtitle">Accede a tu cuenta de Nexus</p>

          <button className="google-btn" onClick={handleGoogleLogin}>
            <GoogleIcon />
            Entrar con Google
          </button>

          {error && <p className="login-error">{error}</p>}

          <p className="login-footer-note">
            Acceso exclusivo para cuentas <strong>@leadsphere.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
